import React from 'react';
import { render } from 'react-dom';
import './styles/tailwind.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const query = window.location.search;
const queryArray = query.split('=')
const key = queryArray[1]

render(
    <React.StrictMode>
      <App config={{key}}/>
    </React.StrictMode>,
    document.getElementById('root')
  );


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
